<template>
    <span class="hide-for-small-only query-term">{{ query }}</span>
</template>

<script>
    export default {
        props: ['initQuery'],
        data: function () {
            return {
                query: this.initQuery
            }
        },
        methods: {
            updateQuery: function(newQuery) {
                this.query = newQuery;
            }
        }
    }
</script>
